
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/print-on-demand-for-wix",
      function () {
        return require("private-next-pages/page/print-on-demand-for-wix.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/print-on-demand-for-wix"])
      });
    }
  